import {Select, Typography} from "components";
import {useAppDispatch, useAppSelector} from "hooks";
import {TableRow, TableCell, TableBody} from "@mui/material";
import {updatePaymentStatus} from "global/slices/payments/thunks";
import {PAYMENT_LIST_OPTION, PAYMENT_STATUS_ENUM_COLORS} from "utils";

interface BodyProps {}

export const Body: React.FC<BodyProps> = () => {
  const dispatch = useAppDispatch();
  const {payments} = useAppSelector("payments");

  return (
    <TableBody>
      {payments.map((payment, key) => {
        const {id, amount, cliente, approved, reference} = payment;
        const {nombre, apellido, cedula} = cliente;

        return (
          <TableRow hover key={`${id}-${key}`} tabIndex={-1}>
            <TableCell>
              <Typography>
                {nombre} {apellido}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>{cedula}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{amount}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{reference}</Typography>
            </TableCell>
            <TableCell>
              <Select
                defaultValue={approved}
                containerStyle={{maxWidth: 150}}
                style={{
                  cursor: "pointer",
                  color: PAYMENT_STATUS_ENUM_COLORS[Number(approved)],
                  border: `2px solid ${
                    PAYMENT_STATUS_ENUM_COLORS[Number(approved)]
                  }`,
                }}
                options={PAYMENT_LIST_OPTION.map(({value, label}) => ({
                  value,
                  label,
                }))}
                onChange={({target}) => {
                  dispatch(
                    updatePaymentStatus({
                      id: Number(id),
                      approved: Number(target["value"]),
                    }),
                  );
                }}
              />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
